// extracted by mini-css-extract-plugin
export var container = "MyBoxPage_container__5Q4dm";